export const defaultTimezoneKey = 'GMT0200';
